import React, { useRef } from "react";
import { useLocation } from "react-router";
import { digitsThree } from "../../utils/price";
import { publicImageProps } from "../../services/config";
import Button from "../../components/common/button/Button";
import VendorProductStatusModal from "./sub-components/vendor-product-status-modal/VendorProductStatusModal";

function ShowVendorProduct() {
  const location = useLocation();
    const vendorProductRef=useRef()

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 text-gray-800">
      <VendorProductStatusModal ref={vendorProductRef} data={location?.state}/>
      <div className="flex justify-between items-center mb-4">
        <h3>اطلاعات محصول {location?.state?.name || ""}</h3>
        <Button onClick={()=>vendorProductRef.current.showModal()} type="button" color="primary" text={'تغییر وضعیت'}/>
      </div>
      <div className="flex flex-col mt-4 border rounded-xl border-gray-200 p-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <p>نام : {location?.state?.name || ""}</p>
          </div>
          <div>
            <p>قیمت : {location?.state?.basePrice || ""}</p>
          </div>
          <div>
            <p>کد : {location?.state?.code || ""}</p>
          </div>
          <div>
            <p>توضیحات : {location?.state?.description || ""}</p>
          </div>
          <div>
            <p>تخفیف : {digitsThree(location?.state?.discountPrice)}</p>
          </div>
          <div>
            <p>موجودی : {location?.state?.inventoryStatus || ""}</p>
          </div>
          <div>
            <p>وضعیت : {location?.state?.status || ""}</p>
          </div>
        </div>
        <div className="flex flex-col mt-4">
          <h3>عکس های محصول</h3>
          {location?.state?.images?.length ? (
            <div className="flex flex-row gap-4 items-center mt-4">
              {location?.state?.images.map((item) => {
                return (
                  <img
                    className="rounded-lg w-56 h-56"
                    {...publicImageProps(item, { vendor: true })}
                    alt=""
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex justify-between items-center my-4">
        <h3>مشخصات غرفه</h3>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 mt-4 border rounded-xl border-gray-200 p-4">
        <div>
          <p>نام : {location?.state?.vendorStore?.name || ""}</p>
        </div>
        <div>
          <p>کد : {location?.state?.vendorStore?.code || ""}</p>
        </div>
        <div>
          <p>آدرس : {location?.state?.vendorStore?.address || ""}</p>
        </div>
        <div>
          <p>توضیحات : {location?.state?.vendorStore?.description || ""}</p>
        </div>
        <div>
          <p>موبایل : {location?.state?.vendorStore?.mobile || ""}</p>
        </div>
        <div>
          <p>آیدی ایتا : {location?.state?.vendorStore?.eitaaId || ""}</p>
        </div>
        <div>
          <p>آیدی بله : {location?.state?.vendorStore?.baleId || ""}</p>
        </div>
      </div>
      <div className="flex justify-between items-center my-4">
        <h3>مشخصات غرفه دار</h3>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 mt-4 border rounded-xl border-gray-200 p-4">
        <div>
          <p>نام : {location?.state?.vendorStore?.user?.name || ""}</p>
        </div>
        <div>
          <p>موبایل : {location?.state?.vendorStore?.user?.mobile || ""}</p>
        </div>
        <div>
          <p>نقش : {location?.state?.vendorStore?.user?.role || ""}</p>
        </div>
      </div>
    </div>
  );
}

export default ShowVendorProduct;
